import { InputAttributeProps } from '@src/components/reusable/input/BaseInput/types';
import { LayoutColors } from '@src/core/theme';
import { BodyExtraSmall, BodySmallMedium } from '@src/fonts/typography/Typography';
import styled, { css } from 'styled-components';

export const InputSpacing = css`
  border: 1px solid ${LayoutColors.blackLight};
  border-radius: 4px;
  padding: 10px;
  box-sizing: border-box;
  padding: 10px;
`;

export const InputArea = styled.div`
  display: block;
`;

export const InputLabel = styled.label`
  ${BodySmallMedium};
  display: block;
  margin-bottom: 8px;
  color: ${LayoutColors.blackMain};
`;

export const InputAttribute = styled.input<InputAttributeProps>`
  ${InputSpacing};
  width: 100%;
  border-color: ${(props) => (props.error ? LayoutColors.errorDark : LayoutColors.blackLight)};
`;

export const InputErrorMessage = styled.div<Pick<InputAttributeProps, 'error'>>`
  ${BodyExtraSmall};
  display: block;
  padding-top: 2px;
  color: ${(props) => (props.error ? LayoutColors.errorDark : LayoutColors.blackMain)};
`;
